import { render, staticRenderFns } from "./defaultReply.vue?vue&type=template&id=17f998c0&scoped=true&"
import script from "./defaultReply.vue?vue&type=script&lang=ts&"
export * from "./defaultReply.vue?vue&type=script&lang=ts&"
import style0 from "./defaultReply.vue?vue&type=style&index=0&id=17f998c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f998c0",
  null
  
)

export default component.exports